export const ColorCode = {
  "warning": "#FFAF1A",
  "hint": "#333333",
  "warningTemplate": "#FFEDCC"
}